var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},_vm._l((_vm.rows),function(row,index){return _c('b-row',{key:index},_vm._l((row),function(tileItem,index){return _c('b-col',{key:index},[_c('dashboard-tile',{attrs:{"item":tileItem}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }